var map = {
	"./": 200,
	"./App": 233,
	"./App.tsx": 233,
	"./components/AboutDialog/AboutDialog": 165,
	"./components/AboutDialog/AboutDialog.tsx": 165,
	"./components/AudioLevelIndicator/AudioLevelIndicator": 91,
	"./components/AudioLevelIndicator/AudioLevelIndicator.tsx": 91,
	"./components/AudioTrack/AudioTrack": 332,
	"./components/AudioTrack/AudioTrack.tsx": 332,
	"./components/Buttons/EndCallButton/EndCallButton": 159,
	"./components/Buttons/EndCallButton/EndCallButton.tsx": 159,
	"./components/Buttons/ToggleAudioButton/ToggleAudioButton": 170,
	"./components/Buttons/ToggleAudioButton/ToggleAudioButton.tsx": 170,
	"./components/Buttons/ToggleChatButton/ToggleChatButton": 266,
	"./components/Buttons/ToggleChatButton/ToggleChatButton.tsx": 266,
	"./components/Buttons/ToggleVideoButton/ToggleVideoButton": 184,
	"./components/Buttons/ToggleVideoButton/ToggleVideoButton.tsx": 184,
	"./components/Buttons/ToogleScreenShareButton/ToggleScreenShareButton": 297,
	"./components/Buttons/ToogleScreenShareButton/ToggleScreenShareButton.tsx": 297,
	"./components/ChatProvider": 93,
	"./components/ChatProvider/": 93,
	"./components/ChatProvider/index": 93,
	"./components/ChatProvider/index.tsx": 93,
	"./components/ChatWindow/ChatInput/ChatInput": 317,
	"./components/ChatWindow/ChatInput/ChatInput.tsx": 317,
	"./components/ChatWindow/ChatWindow": 314,
	"./components/ChatWindow/ChatWindow.tsx": 314,
	"./components/ChatWindow/ChatWindowHeader/ChatWindowHeader": 315,
	"./components/ChatWindow/ChatWindowHeader/ChatWindowHeader.tsx": 315,
	"./components/ChatWindow/MessageList/MediaMessage/MediaMessage": 324,
	"./components/ChatWindow/MessageList/MediaMessage/MediaMessage.tsx": 324,
	"./components/ChatWindow/MessageList/MessageInfo/MessageInfo": 321,
	"./components/ChatWindow/MessageList/MessageInfo/MessageInfo.tsx": 321,
	"./components/ChatWindow/MessageList/MessageList": 320,
	"./components/ChatWindow/MessageList/MessageList.tsx": 320,
	"./components/ChatWindow/MessageList/MessageListScrollContainer/MessageListScrollContainer": 322,
	"./components/ChatWindow/MessageList/MessageListScrollContainer/MessageListScrollContainer.tsx": 322,
	"./components/ChatWindow/MessageList/TextMessage/TextMessage": 323,
	"./components/ChatWindow/MessageList/TextMessage/TextMessage.tsx": 323,
	"./components/ConnectionOptionsDialog/ConnectionOptionsDialog": 304,
	"./components/ConnectionOptionsDialog/ConnectionOptionsDialog.tsx": 304,
	"./components/Countdown/Countdown": 169,
	"./components/Countdown/Countdown.tsx": 169,
	"./components/DeviceSelectionDialog/AudioInputList/AudioInputList": 253,
	"./components/DeviceSelectionDialog/AudioInputList/AudioInputList.tsx": 253,
	"./components/DeviceSelectionDialog/AudioOutputList/AudioOutputList": 255,
	"./components/DeviceSelectionDialog/AudioOutputList/AudioOutputList.tsx": 255,
	"./components/DeviceSelectionDialog/DeviceSelectionDialog": 166,
	"./components/DeviceSelectionDialog/DeviceSelectionDialog.tsx": 166,
	"./components/DeviceSelectionDialog/VideoInputList/VideoInputList": 256,
	"./components/DeviceSelectionDialog/VideoInputList/VideoInputList.tsx": 256,
	"./components/ErrorDialog/ErrorDialog": 336,
	"./components/ErrorDialog/ErrorDialog.tsx": 336,
	"./components/ErrorDialog/ErrorMessages/notAllowedMessages": 188,
	"./components/ErrorDialog/ErrorMessages/notAllowedMessages.ts": 188,
	"./components/ErrorDialog/enhanceMessage": 337,
	"./components/ErrorDialog/enhanceMessage.ts": 337,
	"./components/IntroContainer/IntroContainer": 305,
	"./components/IntroContainer/IntroContainer.tsx": 305,
	"./components/IntroContainer/UserMenu/UserAvatar/UserAvatar": 524,
	"./components/IntroContainer/UserMenu/UserAvatar/UserAvatar.tsx": 524,
	"./components/IntroContainer/VideoLogo": 307,
	"./components/IntroContainer/VideoLogo.tsx": 307,
	"./components/IntroContainer/logo": 308,
	"./components/IntroContainer/logo.tsx": 308,
	"./components/IntroContainer/swoosh": 306,
	"./components/IntroContainer/swoosh.ts": 306,
	"./components/LocalAudioLevelIndicator/LocalAudioLevelIndicator": 302,
	"./components/LocalAudioLevelIndicator/LocalAudioLevelIndicator.tsx": 302,
	"./components/MainParticipant/MainParticipant": 333,
	"./components/MainParticipant/MainParticipant.tsx": 333,
	"./components/MainParticipantInfo/MainParticipantInfo": 334,
	"./components/MainParticipantInfo/MainParticipantInfo.tsx": 334,
	"./components/MenuBar/Menu/Menu": 164,
	"./components/MenuBar/Menu/Menu.tsx": 164,
	"./components/MenuBar/MenuBar": 234,
	"./components/MenuBar/MenuBar.tsx": 234,
	"./components/MobileTopMenuBar/MobileTopMenuBar": 298,
	"./components/MobileTopMenuBar/MobileTopMenuBar.tsx": 298,
	"./components/NetworkQualityLevel/NetworkQualityLevel": 189,
	"./components/NetworkQualityLevel/NetworkQualityLevel.tsx": 189,
	"./components/Participant/Participant": 327,
	"./components/Participant/Participant.tsx": 327,
	"./components/ParticipantInfo/ParticipantConnectionIndicator/ParticipantConnectionIndicator": 525,
	"./components/ParticipantInfo/ParticipantConnectionIndicator/ParticipantConnectionIndicator.tsx": 525,
	"./components/ParticipantInfo/ParticipantInfo": 328,
	"./components/ParticipantInfo/ParticipantInfo.tsx": 328,
	"./components/ParticipantInfo/PinIcon/PinIcon": 330,
	"./components/ParticipantInfo/PinIcon/PinIcon.tsx": 330,
	"./components/ParticipantList/ParticipantList": 326,
	"./components/ParticipantList/ParticipantList.tsx": 326,
	"./components/ParticipantTracks/ParticipantTracks": 191,
	"./components/ParticipantTracks/ParticipantTracks.tsx": 191,
	"./components/PreJoinScreens/DeviceSelectionScreen/DeviceSelectionScreen": 300,
	"./components/PreJoinScreens/DeviceSelectionScreen/DeviceSelectionScreen.tsx": 300,
	"./components/PreJoinScreens/DeviceSelectionScreen/LocalVideoPreview/LocalVideoPreview": 301,
	"./components/PreJoinScreens/DeviceSelectionScreen/LocalVideoPreview/LocalVideoPreview.tsx": 301,
	"./components/PreJoinScreens/DeviceSelectionScreen/SettingsMenu/SettingsMenu": 303,
	"./components/PreJoinScreens/DeviceSelectionScreen/SettingsMenu/SettingsMenu.tsx": 303,
	"./components/PreJoinScreens/MediaErrorSnackbar/MediaErrorSnackbar": 309,
	"./components/PreJoinScreens/MediaErrorSnackbar/MediaErrorSnackbar.tsx": 309,
	"./components/PreJoinScreens/PreJoinScreens": 299,
	"./components/PreJoinScreens/PreJoinScreens.tsx": 299,
	"./components/Publication/Publication": 331,
	"./components/Publication/Publication.tsx": 331,
	"./components/ReconnectingNotification/ReconnectingNotification": 312,
	"./components/ReconnectingNotification/ReconnectingNotification.tsx": 312,
	"./components/Room/Room": 313,
	"./components/Room/Room.tsx": 313,
	"./components/Snackbar/Snackbar": 142,
	"./components/Snackbar/Snackbar.tsx": 142,
	"./components/UnsupportedBrowserWarning/UnsupportedBrowserWarning": 340,
	"./components/UnsupportedBrowserWarning/UnsupportedBrowserWarning.tsx": 340,
	"./components/UserAvatar/UserAvatar": 186,
	"./components/UserAvatar/UserAvatar.tsx": 186,
	"./components/VideoProvider": 87,
	"./components/VideoProvider/": 87,
	"./components/VideoProvider/AttachVisibilityHandler/AttachVisibilityHandler": 235,
	"./components/VideoProvider/AttachVisibilityHandler/AttachVisibilityHandler.tsx": 235,
	"./components/VideoProvider/index": 87,
	"./components/VideoProvider/index.tsx": 87,
	"./components/VideoProvider/useHandleRoomDisconnection/useHandleRoomDisconnection": 236,
	"./components/VideoProvider/useHandleRoomDisconnection/useHandleRoomDisconnection.ts": 236,
	"./components/VideoProvider/useHandleTrackPublicationFailed/useHandleTrackPublicationFailed": 237,
	"./components/VideoProvider/useHandleTrackPublicationFailed/useHandleTrackPublicationFailed.ts": 237,
	"./components/VideoProvider/useLocalTracks/useLocalTracks": 238,
	"./components/VideoProvider/useLocalTracks/useLocalTracks.ts": 238,
	"./components/VideoProvider/useRestartAudioTrackOnDeviceChange/useRestartAudioTrackOnDeviceChange": 249,
	"./components/VideoProvider/useRestartAudioTrackOnDeviceChange/useRestartAudioTrackOnDeviceChange.ts": 249,
	"./components/VideoProvider/useRoom/useRoom": 250,
	"./components/VideoProvider/useRoom/useRoom.tsx": 250,
	"./components/VideoProvider/useScreenShareToggle/useScreenShareToggle": 252,
	"./components/VideoProvider/useScreenShareToggle/useScreenShareToggle.tsx": 252,
	"./components/VideoProvider/useSelectedParticipant/useSelectedParticipant": 88,
	"./components/VideoProvider/useSelectedParticipant/useSelectedParticipant.tsx": 88,
	"./components/VideoTrack/VideoTrack": 121,
	"./components/VideoTrack/VideoTrack.tsx": 121,
	"./constants": 71,
	"./constants.ts": 71,
	"./hooks/useChatContext/useChatContext": 75,
	"./hooks/useChatContext/useChatContext.ts": 75,
	"./hooks/useCountdown/useCountdown": 262,
	"./hooks/useCountdown/useCountdown.tsx": 262,
	"./hooks/useDevices/useDevices": 54,
	"./hooks/useDevices/useDevices.tsx": 54,
	"./hooks/useDominantSpeaker/useDominantSpeaker": 193,
	"./hooks/useDominantSpeaker/useDominantSpeaker.tsx": 193,
	"./hooks/useFlipCameraToggle/useFlipCameraToggle": 261,
	"./hooks/useFlipCameraToggle/useFlipCameraToggle.tsx": 261,
	"./hooks/useHeight/useHeight": 335,
	"./hooks/useHeight/useHeight.ts": 335,
	"./hooks/useIsTrackEnabled/useIsTrackEnabled": 167,
	"./hooks/useIsTrackEnabled/useIsTrackEnabled.tsx": 167,
	"./hooks/useIsTrackSwitchedOff/useIsTrackSwitchedOff": 190,
	"./hooks/useIsTrackSwitchedOff/useIsTrackSwitchedOff.tsx": 190,
	"./hooks/useLocalAudioToggle/useLocalAudioToggle": 265,
	"./hooks/useLocalAudioToggle/useLocalAudioToggle.tsx": 265,
	"./hooks/useLocalVideoToggle/useLocalVideoToggle": 160,
	"./hooks/useLocalVideoToggle/useLocalVideoToggle.tsx": 160,
	"./hooks/useMainParticipant/useMainParticipant": 192,
	"./hooks/useMainParticipant/useMainParticipant.tsx": 192,
	"./hooks/useMediaStreamTrack/useMediaStreamTrack": 74,
	"./hooks/useMediaStreamTrack/useMediaStreamTrack.ts": 74,
	"./hooks/useParticipantIsReconnecting/useParticipantIsReconnecting": 145,
	"./hooks/useParticipantIsReconnecting/useParticipantIsReconnecting.ts": 145,
	"./hooks/useParticipantNetworkQualityLevel/useParticipantNetworkQualityLevel": 329,
	"./hooks/useParticipantNetworkQualityLevel/useParticipantNetworkQualityLevel.tsx": 329,
	"./hooks/useParticipants/useParticipants": 194,
	"./hooks/useParticipants/useParticipants.tsx": 194,
	"./hooks/usePublicationIsTrackEnabled/usePublicationIsTrackEnabled": 526,
	"./hooks/usePublicationIsTrackEnabled/usePublicationIsTrackEnabled.tsx": 526,
	"./hooks/usePublications/usePublications": 143,
	"./hooks/usePublications/usePublications.tsx": 143,
	"./hooks/useRoomState/useRoomState": 92,
	"./hooks/useRoomState/useRoomState.tsx": 92,
	"./hooks/useScreenShareParticipant/useScreenShareParticipant": 79,
	"./hooks/useScreenShareParticipant/useScreenShareParticipant.tsx": 79,
	"./hooks/useScreenShareToggle/useScreenShareToggle": 527,
	"./hooks/useScreenShareToggle/useScreenShareToggle.tsx": 527,
	"./hooks/useTrack/useTrack": 144,
	"./hooks/useTrack/useTrack.tsx": 144,
	"./hooks/useVideoContext/useVideoContext": 10,
	"./hooks/useVideoContext/useVideoContext.ts": 10,
	"./hooks/useVideoTrackDimensions/useVideoTrackDimensions": 257,
	"./hooks/useVideoTrackDimensions/useVideoTrackDimensions.tsx": 257,
	"./icons/AvatarIcon": 187,
	"./icons/AvatarIcon.tsx": 187,
	"./icons/ChatIcon": 267,
	"./icons/ChatIcon.tsx": 267,
	"./icons/CloseIcon": 316,
	"./icons/CloseIcon.tsx": 316,
	"./icons/EndAppointmentIcon": 258,
	"./icons/EndAppointmentIcon.tsx": 258,
	"./icons/ErrorIcon": 310,
	"./icons/ErrorIcon.tsx": 310,
	"./icons/FileAttachmentIcon": 318,
	"./icons/FileAttachmentIcon.tsx": 318,
	"./icons/FileDownloadIcon": 325,
	"./icons/FileDownloadIcon.tsx": 325,
	"./icons/FlipCameraIcon": 260,
	"./icons/FlipCameraIcon.tsx": 260,
	"./icons/InfoIcon": 528,
	"./icons/InfoIcon.tsx": 528,
	"./icons/InfoIconOutlined": 259,
	"./icons/InfoIconOutlined.tsx": 259,
	"./icons/MicIcon": 263,
	"./icons/MicIcon.tsx": 263,
	"./icons/MicOffIcon": 264,
	"./icons/MicOffIcon.tsx": 264,
	"./icons/ScreenShareIcon": 185,
	"./icons/ScreenShareIcon.tsx": 185,
	"./icons/SendMessageIcon": 319,
	"./icons/SendMessageIcon.tsx": 319,
	"./icons/SettingsIcon": 168,
	"./icons/SettingsIcon.tsx": 168,
	"./icons/SuccessIcon": 529,
	"./icons/SuccessIcon.tsx": 529,
	"./icons/VideoOffIcon": 295,
	"./icons/VideoOffIcon.tsx": 295,
	"./icons/VideoOnIcon": 296,
	"./icons/VideoOnIcon.tsx": 296,
	"./icons/WarningIcon": 311,
	"./icons/WarningIcon.tsx": 311,
	"./index": 200,
	"./index.tsx": 200,
	"./state": 16,
	"./state/": 16,
	"./state/index": 16,
	"./state/index.tsx": 16,
	"./state/settings/settingsReducer": 163,
	"./state/settings/settingsReducer.ts": 163,
	"./state/useActiveSinkId/useActiveSinkId": 251,
	"./state/useActiveSinkId/useActiveSinkId.ts": 251,
	"./theme": 341,
	"./theme.ts": 341,
	"./types": 338,
	"./types.ts": 338,
	"./utils": 38,
	"./utils/": 38,
	"./utils/ParticipantStatus/updateParticipant": 119,
	"./utils/ParticipantStatus/updateParticipant.tsx": 119,
	"./utils/index": 38,
	"./utils/index.ts": 38,
	"./utils/redirectRootPath": 120,
	"./utils/redirectRootPath.ts": 120,
	"./utils/useConnectionOptions/useConnectionOptions": 339,
	"./utils/useConnectionOptions/useConnectionOptions.ts": 339,
	"./videoApp": 232,
	"./videoApp.tsx": 232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 536;